import React from 'react'
import { makeStyles, withStyles } from '@material-ui/styles'
import { Menu, MenuItem } from '@material-ui/core'

export const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
))

export const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.secondary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem)

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: 0,
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  actions: {
    justifyContent: 'flex-end',
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  item: {
    padding: theme.spacing(1),
  },
  botoesAcao: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1),
  },
  menuList: {
    display: 'flex',
  },
  custodiaAlert: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    padding: theme.spacing(2),
    borderRadius: '8px',
    marginBottom: theme.spacing(3),
    boxSizing: 'border-box',
    border: '1px solid',
    gap: theme.spacing(2),
  },
  custodiaAlertWarning: {
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(251, 138, 0, 0.1)' : 'rgba(251, 138, 0, 0.05)',
    borderColor: theme.palette.type === 'dark' ? 'rgba(251, 138, 0, 0.3)' : 'rgba(251, 138, 0, 0.2)',
    borderLeft: '5px solid #fb8a00',
  },
  custodiaAlertInfo: {
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(33, 150, 243, 0.1)' : 'rgba(33, 150, 243, 0.05)',
    borderColor: theme.palette.type === 'dark' ? 'rgba(33, 150, 243, 0.3)' : 'rgba(33, 150, 243, 0.2)',
    borderLeft: '5px solid #2196f3',
  },
  custodiaAlertContent: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'flex-start',
    flex: 1,
    minWidth: 0,
  },
  custodiaAlertIconWarning: {
    color: '#fb8a00',
    fontSize: '2rem',
    marginTop: '2px',
    flexShrink: 0,
  },
  custodiaAlertIconInfo: {
    color: '#2196f3',
    fontSize: '2rem',
    marginTop: '2px',
    flexShrink: 0,
  },
  custodiaAlertTexts: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    flex: 1,
    minWidth: 0,
  },
  custodiaAlertTitle: {
    fontWeight: 600,
    fontSize: '1rem',
    color: theme.palette.text.primary,
  },
  custodiaAlertDescription: {
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
  },
  custodiaAlertObs: {
    padding: theme.spacing(1, 1.5),
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.03)',
    borderRadius: '6px',
    borderLeft: '3px solid rgba(0, 0, 0, 0.2)',
    fontStyle: 'italic',
    fontSize: '0.85rem',
    color: theme.palette.text.primary,
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
  },
  custodiaAlertActions: {
    display: 'flex',
    gap: theme.spacing(1.5),
    flexWrap: 'nowrap',
    alignItems: 'center',
    flexShrink: 0,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      justifyContent: 'flex-end',
    },
  },
}))

export default useStyles
